import { initialValues, getLanguageOptions } from './EditSchool.formConfig';

export const convertDataToApi = (data: any) => ({
  preview: data.preview,
  name: data.name,
  language: data.language ? data.language.value : null,
});

export const convertDataToForm = (data: any) => {
  if (!data) {
    return initialValues;
  }

  return {
    id: data.id,
    name: data.name,
    preview: data.preview,
    language: getLanguageOptions().find(
      (option: any) => option.value === data.language,
    ),
  };
};
